import React from "react";
import styled from "styled-components";
import DrawerRecording from "../../../internal/ViewRecording/ViewRecording";
import { Strip, TabBtn, TabLabel } from "./CaseTabStrip";
import {
  ControlsRow,
  ControlsGroup,
  CardSlot,
  LinkSlot,
} from "../../../pages/CaseDetails";
import { HyperLink } from "../../ClaimItemsListModal";
import { CaseManagerCardData } from "../../../pages/CaseDetails/styles";
import { PrimaryCTAButton } from "../../Buttons";
import { navigate } from "@reach/router";

export default function HearingsAndTranscrips({
  open,
  setOpen,
  caseId,
  id = "",
  heading = "Hearings & Transcripts",
  type,
  viewOnly,

  // hearings

  state,
  isActionsDisabled,
  isNonNegotiation,
  isNotDraft,
  mediatorTitle,
  meetingOpen,
  setSettingsModal,
  setPublicModal,
  transcriptControl,
  settranscriptControl,
  setRefreshDetails,
  meetingDetail,
  stopTranscriptionAlert = () => { },
  pushCaseToArbitrationAlert = () => { },
  caseDetails,
  tab,
  setState,
  startTranscription = () => { },
  setRefreshStatus,
  generateRTMPLink = () => { },
  MTRef,
  setMeetingDetail,
}) {
  return (
    <>
      <Container>
        <ControlsGroup>
          {caseDetails?.resolutionKind !== "negotiation" && (
            <>
              <CardSlot>
                <CaseManagerCardData>
                  <PrimaryCTAButton
                    style={{ width: "295px" }}
                    onClick={() =>
                      navigate(
                        type?.crossExamination
                          ? `/view/cases/${id}/cross-examination?caseType=${caseDetails?.resolutionKind}`
                          : `/view/cases/${id}/livetranscription?caseType=${caseDetails?.resolutionKind}`,
                        {
                          state: type?.crossExamination ? type : caseDetails,
                        },
                      )
                    }
                  >
                    {type?.crossExamination
                      ? "Cross Examination"
                      : "Live Transcription"}
                  </PrimaryCTAButton>
                </CaseManagerCardData>
              </CardSlot>
            </>
          )}
        </ControlsGroup>
        <Content>
          {type !== "negotiation" &&
              viewOnly !== true && (
                <DrawerRecording
                  title="View Recordings"
                  id={id}
                  setState={() => { }}
                  type={type}
                />
              )}
        </Content>
      </Container>
    </>
  );
}

export const Container = styled.div`
  width: 100%;
  padding: 12px 0;

  @media (max-width: 768px) {
    padding: 8px 0;
  }
`;

export const Content = styled.div`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  margin-top: 20px;
`;

export const TabBody = styled.div`
  padding: 16px;

  @media (max-width: 768px) {
    padding: 12px;
  }
`;
